<div class="app-container">
    <app-loader [show]="showLoader"></app-loader>
    <router-outlet />
</div>
